// extracted by mini-css-extract-plugin
var _1 = "Toggle__main--xeGGW";
var _2 = "Toggle__off--ZV6zo";
var _3 = "Toggle__on--OsR8g";
export { _1 as "main", _2 as "off", _3 as "on" }
